<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" @click.self="close">
    <div class="relative max-w-full max-h-full">
      <button 
        @click="close"
        class="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors z-10"
        aria-label="Close"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <!-- Use SecureWallpaperImage instead of regular img tag -->
      <template v-if="wallpaperId">
        <div class="relative">
          <SecureWallpaperImage
            :image-url="src"
            :wallpaper-id="wallpaperId"
            :alt="alt"
            :clickable="true"
            container-class="relative"
            image-class="max-w-[90vw] max-h-[90vh] object-contain cursor-pointer"
            aspect-class="max-w-[90vw] max-h-[90vh]"
            @click="close"
          />
          
          <!-- Centered Watermark Overlay -->
          <div 
            class="absolute inset-0 flex items-center justify-center pointer-events-none"
            style="z-index: 5;"
          >
            <span 
              class="text-white/30 text-3xl font-bold tracking-wider"
              style="text-shadow: 2px 2px 4px rgba(0,0,0,0.5);"
            >
              WallpaperHub
            </span>
          </div>
        </div>
      </template>
      
      <!-- Fallback for cases without wallpaperId (should be rare) -->
      <div 
        v-else
        class="max-w-[90vw] max-h-[90vh] bg-gray-800 rounded-lg flex items-center justify-center p-8"
        @click="close"
      >
        <div class="text-center text-white">
          <svg class="w-16 h-16 mx-auto mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zM12 9V7a4 4 0 118 0v2M8 9h8a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2v-6a2 2 0 012-2z"></path>
          </svg>
          <p class="text-lg font-medium mb-2">Secure Preview Only</p>
          <p class="text-sm opacity-70">Full resolution available after download</p>
        </div>
      </div>
      
      <div class="mt-2 text-center text-white text-sm opacity-70">
        Click anywhere to close
      </div>
    </div>
  </div>
</template>

<script>
import SecureWallpaperImage from './ui/SecureWallpaperImage.vue';

export default {
  name: 'ImageViewer',
  components: {
    SecureWallpaperImage
  },
  props: {
    src: {
      type: String,
      required: true
    },
    wallpaperId: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    // Re-enable body scroll when modal is closed
    document.body.style.overflow = '';
  }
};
</script>
